import { suggestPatientEndpoint } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type { SuggestPatientResponseT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchCareSuggestPatient(
  signal?: AbortSignal
): Promise<SuggestPatientResponseT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await suggestPatientEndpoint(config);
  return lotusHealthZod.suggestPatientEndpointResponse.parse(
    response.data
  ) as SuggestPatientResponseT;
}
